"use client"

import { Separator, Spinner, Text } from "@/elements"
import React, { FC, useRef } from "react"
import { PageInfo } from "@/gql/graphql"
import { ApolloQueryResult, FetchMoreOptions, FetchMoreQueryOptions } from "@apollo/client"
import { useHandleListEndReached } from "@/hooks/useHandleListEndReached"
import { cn } from "@/utils/classnames"

interface Props {
  onSelect: (item: { name: string; id: string }) => void
  options: ({ name: string; id: string } | undefined)[] | undefined
  placeholder?: string
  dropdownClassName?: string
  loading: boolean
  pageInfo?: Pick<PageInfo, "hasNextPage" | "endCursor">
  pageSize?: number
  networkStatus: number
  fetchMore?: (
    fetchMoreOptions: FetchMoreQueryOptions<any, any> & FetchMoreOptions<any, any>
  ) => Promise<ApolloQueryResult<any>>
  toggleDropdown: (value: boolean) => void
}

export const DropdownPopoverContent: FC<Props> = ({
  onSelect,
  options,
  toggleDropdown,
  dropdownClassName,
  pageSize,
  fetchMore,
  networkStatus,
  loading,
  pageInfo,
}) => {
  const dropDownRef = useRef(null)

  useHandleListEndReached({
    pageInfo,
    networkStatus,
    first: pageSize || 10,
    fetchMore,
    observerRef: dropDownRef,
  })

  return (
    <div
      className={cn(
        "mt-2 flex max-h-[200px] w-full flex-col overflow-y-scroll rounded-md border border-bg-3 bg-bg-1 p-2 shadow-md",
        dropdownClassName
      )}>
      {options?.length && options.length > 0 ? (
        options?.map((item, index) => (
          <div key={index}>
            <div
              onClick={() => {
                if (item) {
                  onSelect(item)
                  toggleDropdown(false)
                }
              }}
              className="cursor-pointer rounded-md px-2 py-2 hover:bg-bg-2">
              <Text variant="body1">{item?.name}</Text>
            </div>
            {index < options.length - 1 && (
              <div className="px-2 py-2">
                <Separator />
              </div>
            )}
          </div>
        ))
      ) : (
        <div className="mx-1 cursor-pointer rounded-md px-2 py-2 hover:bg-bg-2">
          <Text variant="body1">{loading ? "Loading..." : "No options available"}</Text>
        </div>
      )}
      <div ref={dropDownRef} className="h-1" />
      {pageInfo?.hasNextPage && !loading && (
        <div className="relative my-2 flex h-[20px] w-full flex-row items-center justify-center">
          <Spinner size="small" />
        </div>
      )}
    </div>
  )
}
